import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dc777a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-visitor" }
const _hoisted_2 = { class: "invitation" }
const _hoisted_3 = { class: "invitation-title" }
const _hoisted_4 = { class: "invitation-image" }
const _hoisted_5 = {
  class: "i-visitor-list",
  style: {"padding":"20px 0"}
}
const _hoisted_6 = {
  key: 0,
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_7 = { class: "item-p" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 未通过原因： ", -1))
const _hoisted_9 = { class: "item-p__right" }
const _hoisted_10 = {
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_11 = { class: "item-p" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 访问时间： ", -1))
const _hoisted_13 = {
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_14 = { class: "item-p" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 访问公司： ", -1))
const _hoisted_16 = { class: "item-p__right" }
const _hoisted_17 = {
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_18 = { class: "item-p" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 访问原因： ", -1))
const _hoisted_20 = { class: "item-p__right" }
const _hoisted_21 = {
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_22 = { class: "item-p" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 被访人： ", -1))
const _hoisted_24 = { class: "item-p__right" }
const _hoisted_25 = {
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_26 = { class: "item-p" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 被访人手机号： ", -1))
const _hoisted_28 = { class: "item-p__right" }
const _hoisted_29 = {
  class: "i-visitor-item",
  style: {"padding":"0"}
}
const _hoisted_30 = { class: "item-p" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, " 被访人邮箱： ", -1))
const _hoisted_32 = { class: "item-p__right" }
const _hoisted_33 = { class: "item-p" }
const _hoisted_34 = { class: "item-p__left" }
const _hoisted_35 = { class: "item-p__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" 您的邀请码 "),
        (_ctx.detail.state_name === '未到访问时间')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("(" + _toDisplayString(_ctx.detail.state_name) + ")", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_image, {
          width: "240px",
          height: "240px",
          src: _ctx.imgSrc
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.detail.opt_reason)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.detail.opt_reason), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", {
              class: _normalizeClass(["item-p__right", _ctx.detail.state == '3' ? 'red' : ''])
            }, _toDisplayString(_ctx.detail.person_date) + " " + _toDisplayString(_ctx.detail.person_time), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.detail.visit_stores_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.detail.person_reason), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.detail.visit_user_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.detail.visit_user_mobile), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.detail.visit_user_email), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.visit_diy_field, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "i-visitor-item",
            style: {"padding":"0"},
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(item.title) + "：", 1),
              _createElementVNode("div", _hoisted_35, _toDisplayString(item.content || "-"), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}